export class customEventsNames{
    constructor() {
        this.openModal = 'openModal';
        this.closeModal = 'closeModal';
        this.playVideoInModal = 'playVideoInModal';
        this.playYoutubeVideoInModal = 'playYoutubeVideoInModal';
        this.videoPlayingInModal = 'videoStartedPlayingInModal';
        this.openUserCreationPanel = 'openUserCreationPanel';
        this.openUserLoginPanel = 'openUserLoginPanel';
        this.openContentModal = 'openContentModal';
        this.mobileMenuOpened = 'mobileMenuOpened';
        this.mobileMenuClosed = 'mobileMenuClosed';
    }
};
export default new customEventsNames();